import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  userImg: {
    height: '100%',
  },
  initialsBlock: {
    width: 30,
    height: 30,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.colors.light.lightSteelBlue}`,
    borderRadius: '50%',
    backgroundColor: 'transparent',
  },
  initialsText: {
    color: theme.colors.light.lightSteelBlue,
    fontSize: 12,
    fontWeight: 500,
  },
}));
